import { setLocale } from "../i18n.svelte.js";

export async function changeLocale(locale) {
  setLocale(locale);
}
